import { CommonModule } from '@angular/common';
import { Component, ComponentRef, Inject, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CreditOptions, HTTPSearchResultTour } from 'src/app/models';
import { TourCreditDropdownService } from 'src/app/services/tour-credit-dropdown.service';
import { TourCreditDropdownComponent } from './dropdown/tour-credit-dropdown.component';
import { PriceFormatPipe } from "../../pipes/price-format/price-format.pipe";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-tour-credit',
  templateUrl: './tour-credit.component.html',
  styleUrls: ['./tour-credit.component.scss'],
  standalone: true,
  imports: [CommonModule, PriceFormatPipe]
})
export class TourCreditComponent implements OnInit, OnDestroy {
  @Input() tour: HTTPSearchResultTour;
  // Был запущен поиск по этому туру
  @Input() isSearchRunning: boolean;

  @ViewChild('dropdown', { read: ViewContainerRef }) dropdownRef: ViewContainerRef;
  private dropdownComponentRef: ComponentRef<TourCreditDropdownComponent>;

  // На сколько месяцев кредит
  months: string;
  // Идет поиск туров
  isToursSearching = false;

  constructor(@Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig, private dropdownService: TourCreditDropdownService) { }

  ngOnInit() { }

  ngOnDestroy() { }

  toggleCreditVariant() {
    // Во время поиска не даем открывать
    if (!this.isToursSearching) {
      // Смотрим, открыт выбор кредиов или нет. Если открыт, то просто удаляем его
      if (this.dropdownComponentRef) {
        this.destroyDropdown();
      } else {
        this.dropdownComponentRef = this.dropdownService.open(this.dropdownRef);
        this.dropdownComponentRef.instance.tour = this.tour;
        this.dropdownComponentRef.instance.creditTerms = this.getCreditTermsOptions();
        this.dropdownComponentRef.instance.onClose.subscribe(() => this.destroyDropdown());
      }
    }
  }

  get priceByMonth(): number {
    let price = 0;

    for (const bank in this.hotelToursPageConfig.creditTerms) {
      if (this.hotelToursPageConfig.creditTerms.hasOwnProperty(bank)) {
        const creditOptions: CreditOptions = this.hotelToursPageConfig.creditTerms[bank];
        const monthPayment = Math.ceil(this.tour.price.value * creditOptions.monthCoefficient);

        if (monthPayment > 0 && (price === 0 || monthPayment < price)) {
          price = monthPayment;
          this.months = creditOptions.months.toString();
        }
      }
    }

    return price;
  }

  private getCreditTermsOptions() {
    const options = [];
    for (const bank in this.hotelToursPageConfig.creditTerms) {
      if (this.hotelToursPageConfig.creditTerms.hasOwnProperty(bank)) {
        const creditOptions: CreditOptions = this.hotelToursPageConfig.creditTerms[bank];
        options.push(creditOptions);
      }
    }

    return options;
  }

  private destroyDropdown() {
    this.dropdownComponentRef.instance.onClose.unsubscribe();
    this.dropdownComponentRef.destroy();
    this.dropdownComponentRef = null;
  }
}
